import { join } from 'lodash/fp';
import React, { ReactNode } from 'react';
import { opt, map } from 'ts-opt';
import { FarmRow } from 'api/gen/FarmRow';
import { BreederRoleTableType } from '../../types/breeder-role-table-type';

/**
 * Renders a farm code with a tooltip for the full breeder access list.
 *
 * @param value Code shown in the table cell.
 * @param breederRow Breeder row that provides the tooltip source data.
 * @returns A span with the full farm code list in the title attribute when needed.
 *
 * @example
 * getFarmCodeFormat('F-01', breederRow);
 */
export const getFarmCodeFormat = (value: string, {
  accessToAllFarms,
  farms
}: BreederRoleTableType): ReactNode => {
  const title = opt(farms).noneWhen(!accessToAllFarms).mapFlow(map((farm: FarmRow): string => farm.farmCode), join(', ')).orUndef();
  return <span title={title} data-sentry-component="getFarmCodeFormat" data-sentry-source-file="farm-code-format.tsx">{value}</span>;
};